import {StartTime} from "../services/TimesProvider";
import DateService from "../services/DateService";

export default class MultiTimeBookingDetails {

  id: string
  name: string
  expanded: boolean
  startTimes: StartTime[]
  duration: number
  bufferBefore: number
  bufferAfter: number

  constructor (data: any) {
    this.id = data.bookingType
    this.name = data.name
    this.expanded = data.expanded
    this.startTimes = data.startTimes || null
    this.duration = data.duration || 90 // Default to 90 minutes
    this.bufferBefore = data.bufferBefore || 0
    this.bufferAfter = data.bufferAfter || 0
  }

  hasTimeSelected () : boolean {
    let hasSelection = false
    this.startTimes.forEach((slot: StartTime) => {
      if (slot.selected) {
        hasSelection = true
      }
    })

    return hasSelection
  }

  getSelectedTime () : StartTime | null {
    let selectedTime = null
    this.startTimes.forEach((slot: StartTime) => {
      if (slot.selected) {
        selectedTime = slot
      }
    })

    return selectedTime
  }

  selectTime (slot: StartTime) : void {
    // Mark all other times as disabled
    this.startTimes.forEach((otherSlot: StartTime) => {
      otherSlot.isValid = false
      otherSlot.selected = false
    })

    // Mark slot as selected
    slot.selected = true
    slot.isValid = true
  }

  unselectTime () : void {
    // Mark all times as enabled and unselected
    this.startTimes.forEach((slot: StartTime) => {
      slot.isValid = true
      slot.selected = false
    })
  }

  enableAllTimes (): void {
    this.startTimes.forEach((slot: StartTime) => {
      slot.isValid = true
    })
  }

  disableTimeWindow (windowStart: Date, windowEnd: Date) : void {
    // Disable all time slots that overlap either supplied times
    this.startTimes.forEach((slot: StartTime) => {
      // Calculate start and end times for slot
      let slotStart = new Date()
      slotStart.setHours(slot.time.hours)
      slotStart.setMinutes(slot.time.minutes)
      slotStart.setSeconds(0)

      let slotEnd = new Date(slotStart.valueOf())
      slotEnd.setMinutes(slot.time.minutes + this.duration)

      // If slot start falls between start and end times, disable slot
      if (slotStart >= windowStart && slotStart <= windowEnd) {
        slot.isValid = false
      }

      // If slot end falls between start and end times, disable slot
      if (slotEnd >= windowStart && slotEnd <= windowEnd) {
        slot.isValid = false
      }

      // Check slot doesn't fit entirely inside window
      if (slotStart >= windowStart && slotEnd <= windowEnd) {
        slot.isValid = false
      }

      // Check window doesn't fit entirely inside slot
      if (windowStart >= slotStart && windowEnd <= slotEnd) {
        slot.isValid = false
      }
    })
  }

  getDescription () {
    // Get currently selected time (if there is one)
    let description = this.name
    const startTime = this.getSelectedTime()

    if (startTime) {
      description += ' - ' + startTime.friendlyTime()
      description += ' until '

      const endTime = DateService.addMinutesToTime(this.duration, startTime.time)

      description += DateService.friendlyTime({
        hours: endTime.getHours(),
        minutes: endTime.getMinutes()
      })
    }

    return description
  }

}



// WEBPACK FOOTER //
// ./src/models/MultiTimeBookingDetails.ts